export function sendEvent(eventKey, options = {}) {
    if(!window || !window.dataLayer) return

    window.dataLayer.push({
        ...options,
        event: eventKey,
    })
}
